import React from 'react';
import MainPage from './pages/MainPage/MainPage.component';

function App() {
  return <MainPage />
}

export default App;
